import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import firebase, { User as FirebaseUser } from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import constants from './constants/constants';
import { User } from './models/user';
import './filters/filters';
import VueFroala from 'vue-froala-wysiwyg';
import 'froala-editor/js/froala_editor.pkgd.min.js';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/js/plugins/link.min.js';
import 'froala-editor/js/plugins/image.min.js';
import 'froala-editor/js/plugins/file.min.js';
import 'froala-editor/js/plugins.pkgd.min.js';

Vue.config.productionTip = false;
Vue.use(VueFroala);
firebase.initializeApp(constants.FIREBASE.firebaseConfig);
console.log(constants.FIREBASE.firebaseConfig);

export const db = firebase.firestore();
// if (location.hostname === 'localhost') {
//   db.settings({
//     host: 'localhost:8087',
//     ssl: false,
//   });
// }
let userListener: (() => void) | null = null;

firebase.auth().onAuthStateChanged(async (user) => {
  console.log('state change');
  console.log(user);
  if (!user && router.currentRoute.name !== 'SignIn') {
    router.push({ name: 'SignIn' });
  }
  store.commit('updateFirebaseUser', user);
  if (user && !userListener) {
    userListener = db
      .collection('users')
      .doc(user.uid)
      .onSnapshot(
        (doc) => {
          if (doc.data()) {
            store.commit('updateCurrentUser', doc.data() as User);
            console.log(doc.data() as User);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }
});

firebase
  .firestore()
  .enablePersistence()
  .catch((err) => {
    if (err.code === 'failed-precondition') {
      console.log(err);
    } else if (err.code === 'unimplemented') {
      console.log('persistence not supported');
    }
  });

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
